import fetch from 'isomorphic-fetch'

const API_URL_AVT = import.meta.env.VITE_AVT_API_URL

const createRequestBody = (requestObj) => {
  return {
    method: requestObj.method,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(requestObj.body)
  }
}

const jsonToQuery = (json) => {
  return Object.keys(json)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(json[key]))
    .join('&')
}

const userList = async (params) => {
  const query = jsonToQuery(params)
  const requestUrl = `${API_URL_AVT}/odin/api/users?${query}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getUser = async (userId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/users/${userId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const userCreate = async ({ firstName, lastName, email, password, roleId, isLive, groups }) => {
  const requestUrl = `${API_URL_AVT}/odin/api/users`

  const requestBody = createRequestBody({
    method: 'POST',
    body: {
      firstName,
      lastName,
      email,
      password,
      roleId,
      isLive,
      groups
    }
  })
  return fetch(requestUrl, requestBody)
}

const getGroups = async (params) => {
  const query = jsonToQuery(JSON.parse(JSON.stringify(params)))
  const requestUrl = `${API_URL_AVT}/odin/api/groups?${query}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getFlagCategories = async () => {
  const requestUrl = `${API_URL_AVT}/odin/api/flag-categories`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const getGroup = async (groupId) => {
  const requestUrl = `${API_URL_AVT}/odin/api/group/${groupId}`

  let requestBody = createRequestBody({
    method: 'GET'
  })
  return fetch(requestUrl, requestBody)
}

const createGroup = async (group) => {
  const requestUrl = `${API_URL_AVT}/odin/api/groups`

  const requestBody = createRequestBody({
    method: 'POST',
    body: group
  })
  return fetch(requestUrl, requestBody)
}

const updateGroup = async (groupId, updatedGroup) => {
  const requestUrl = `${API_URL_AVT}/odin/api/groups/${groupId}`

  const requestBody = createRequestBody({
    method: 'PUT',
    body: updatedGroup
  })
  return fetch(requestUrl, requestBody)
}

export { userList, getUser, userCreate, getGroups, getFlagCategories, getGroup, createGroup, updateGroup }
